export default {
    replicas : [],
    replicasSamples : [],
    samplesPerReplicas: null
}